import {Component, ElementRef, EventEmitter, Output, ViewChild, ViewContainerRef} from '@angular/core';

/**
 * Generated class for the CommandOutputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'command-output',
  // templateUrl: 'command-output.html'
  template:'<div style="border-top:orange solid thin; background:lightgray" class="command">>{{command}}</div><div #container class="output"></div>'
})
export class CommandOutputComponent {

  @Output() commandOutputComponentInitialized: EventEmitter<any> = new EventEmitter;
  command: string;
  @ViewChild('container', {read:ViewContainerRef}) container: ViewContainerRef;

  constructor(public element:ElementRef) {
    console.log('Hello CommandOutputComponent Component');

  }

  ngAfterViewInit(){
    console.log("dispatching!")
    this.element.nativeElement.dispatchEvent(new CustomEvent("commandOutputComponentInitialized", {bubbles:true}));
    // this.element.nativeElement.scrollIntoView({behavior:"smooth"})
  }

}



// WEBPACK FOOTER //
// ./src/components/command-output/command-output.ts